import * as React from 'react';

function SvgWarningFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.52 4.476L26.902 25.24a1.7 1.7 0 01-1.52 2.46H4.618a1.7 1.7 0 01-1.52-2.46L13.478 4.476a1.7 1.7 0 013.041 0z"
        fill="#414B56"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 12h-2v7h2v-7zm0 9h-2v2h2v-2z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgWarningFilled;
